import React, { Component } from 'react';

class ReportCard extends Component {

  isCommingSoon = () => {
    switch(this.props.title.toLowerCase())
    {
      case "royalty report":
        return false;
      case "lead and sign up report":
        return false;
      case "cancellation report":
        return false;
      case "coupon code report":
        return false;
      case "job completed to invoiced reconciliation report":
        return false;
      case "price increase report":
        return false;
      default:
        return true;
    }
  }

  render() {
    const is_comming_soon = this.isCommingSoon();
    
    return (
      <div className="card report-card">
        <div className="card-title">
        <h5>{ !is_comming_soon ? this.props.title : `Coming Soon: ${this.props.title}` }</h5> 
        </div>
        <div className="card-body lh-21">
          {this.props.description}
        </div>
        <div className="card-footer pt-0">
          { !is_comming_soon && <button className="btn btn-warning" onClick={() => this.props.loadReport(this.props.id)}>Run Report</button>}
        </div>
      </div>
    );
  }
}

export default ReportCard;